import {useGuestGroup, usePetFeeDeal, useTaxes} from 'hooks';
import {useReservation} from 'context/reservation';

export function useIsReservationSettingsReady() {
  const {housing} = useReservation();
  const {guestGroup} = useGuestGroup();
  const {isLoading: isTaxesLoading} = useTaxes();
  const {isLoadingPetFeeOffer} = usePetFeeDeal();

  return (
    Boolean(housing) && Boolean(guestGroup) && !isTaxesLoading && !isLoadingPetFeeOffer
  );
}
